import axios from 'axios'
import Config from "../../config/Config";
import {authenticationService} from "../AuthenticationService";


const AllUsersApi = {
    signIn: async (username, password, reCaptchaToken) => {

        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "Hidden",
                "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token"
            }
        };
        let body = {
            "Email": username,
            "Password": password,
            "reCaptchaToken": reCaptchaToken
        };
        try {
            return await axios.post(
                `${Config.globalUrl}/api/v1/webapp/signin`,
                body,
                requestconfig
            );
        } catch (err) {
            return err
        }


    },
    PatientLogin: async (ID_passport, Phone_num1, reCaptchaToken) => {

        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "Hidden",
                "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token"
            }
        };
        let body = {
            "ID_passport": ID_passport,
            "Phone_num1": Phone_num1,
            "reCaptchaToken": reCaptchaToken
        };
        try {
            return await axios.post(
                `${Config.globalUrl}/api/v1/webapp/patientsignin`,
                body,
                requestconfig
            );
        } catch (err) {
            return err
        }
    },

    getPatientFromRoute: async (token, UserStorageID) => {

        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "Hidden",
                "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
                'Authorization': token,
            }
        };
        try {
            return await axios.get(
                `${Config.globalUrl}/api/v1/webapp/patient/${UserStorageID}/getPatientFromRoute`,
                requestconfig
            );
        } catch (err) {
            return err
        }
    },
    submit2fa: async (code, reCaptchaToken) => {
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentMfaUserValue.token,
            }
        };
        try {
            return await axios.post(
                `${Config.globalUrl}/api/v1/webapp/signin/2fa`,
                {TwoFaCode: code.split(" ").join(""), reCaptchaToken: reCaptchaToken},
                requestconfig
            );
        } catch (err) {
            return err
        }

    },
    changeNewPassword: async (password, termOfUseSigned) => {
        if (!authenticationService.pwdUserValue) return;
        let token = authenticationService.pwdUserValue.token
        let url = `${Config.globalUrl}/api/v1/webapp/users/${authenticationService.pwdUserValue.profile.UserStorageID}/changePass`
        try {
            return await axios.post(
                url,
                {
                    termOfUseSigned,
                    newPassword: password.split(" ").join("")
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token,
                        //'app_client_version': version
                    }
                }
            );
        } catch (err) {
            return err
        }

    },
    resetPassword: async (email, reCaptchaToken) => {
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "Hidden",
                "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token"
            }
        };
        let body = {
            "Email": email,
            "reCaptchaToken": reCaptchaToken
        };
        try {
            return await axios.post(
                `${Config.globalUrl}/api/v1/webapp/forgetPass`,
                body,
                requestconfig
            );
        } catch (err) {
            return err
        }


    },

    changeLanguage: async (language) => {
        if (!authenticationService.currentUserValue)
            return;
        let user = authenticationService.currentUserValue;

        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return (await axios.post(
            `${Config.globalUrl}/api/v1/webapp/users/${user.profile.UserStorageID}/changeLanguage`,
            language,
            requestconfig
        ));
    },
    selfRegisterApproving: async (entry) => {
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/users/approving/self/signupApproving`,
            entry,
            requestconfig
        );

    },
    selfRegisterRecommend: async (entry) => {
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/users/recommend/self/signupRecommend`,
            entry,
            requestconfig
        );

    },
};

export default AllUsersApi
